import initialState from './initialState';
import {
  GET_MOVIES_FILTER,
  GET_FILTERED_MOVIES,
  CLEAR_FILTERED_MOVIES,
  GET_MOVIE,
  GET_MOVIE_EPISODES,
  GET_MOVIE_THREAD,
  CLEAR_MOVIE_DATA,
  GET_NEW_MOVIES,
  GET_LAST_MOVIES,
  GET_TOP_MOVIES,
  GET_RECOMMENDED_MOVIES,
} from '../constants';

export default (state = initialState.movies, action) => {
  switch (action.type) {
    case GET_MOVIES_FILTER:
      return {
        ...state,
        availableFilters: action.response,
      };

    case GET_FILTERED_MOVIES:
      return {
        ...state,
        filteredData: {
          status: action.response.status,
          pageLoaded: action.response.pageLoaded,
          hasNext: action.response.hasNext,
          data: state.filteredData.data.concat(action.response.data),
        },
      };

    case CLEAR_FILTERED_MOVIES:
      return {
        ...state,
        filteredData: {
          status: null,
          pageLoaded: 1,
          hasNext: true,
          data: [],
        },
      };

    case GET_MOVIE:
      return {
        ...state,
        movie: action.response,
      };

    case GET_MOVIE_EPISODES:
      return {
        ...state,
        episodes: action.response,
      };

    case GET_MOVIE_THREAD:
      return {
        ...state,
        movieThread: action.response,
      };

    case CLEAR_MOVIE_DATA:
      return {
        ...state,
        movie: {
          status: null,
          data: {},
        },
        movieThreads: {
          status: null,
          data: [],
        },
      };

    case GET_NEW_MOVIES:
      return {
        ...state,
        new: {
          status: action.response.status,
          pageLoaded: action.response.pageLoaded,
          hasNext: action.response.hasNext,
          data: state.new.data.concat(action.response.data),
        },
      };

    case GET_LAST_MOVIES:
      return {
        ...state,
        last: {
          status: action.response.status,
          pageLoaded: action.response.pageLoaded,
          hasNext: action.response.hasNext,
          data: state.last.data.concat(action.response.data),
        },
      };

    case GET_TOP_MOVIES:
      return {
        ...state,
        top: {
          status: action.response.status,
          pageLoaded: action.response.pageLoaded,
          hasNext: action.response.hasNext,
          data: state.top.data.concat(action.response.data),
        },
      };

    case GET_RECOMMENDED_MOVIES:
      return {
        ...state,
        recommended: {
          status: action.response.status,
          pageLoaded: action.response.pageLoaded,
          hasNext: action.response.hasNext,
          data: state.recommended.data.concat(action.response.data),
        },
      };


    default:
      return state;
  }
};
